import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from '../RestApi/restApi';
import { Observable } from 'rxjs';

interface AlertRuleInfo {   
  statusMessage: any;
  error: boolean;
  data: any[];
}

@Injectable({
  providedIn: 'root'
})
export class AlertRuleService {
  private headers = new HttpHeaders({
        "Content-Type": "application/json"
        });
    
        private headerpart = new HttpHeaders({
          'enctype': 'multipart/form-data',  // Ensure the correct encoding
        });

  constructor(
    private restApi: RestApi,
    private http: HttpClient,
  ) { }

   private buildUrl(url: string, params: Record<string, any>): string {
    Object.keys(params).forEach(key => {
    url = url.replace(`{${key}}`, params[key]);
  });
  return url;
}

/* =========================
     CREATE ALERT RULE
     ========================= */
  createAlertRule(payload: any): Observable<AlertRuleInfo> {
    return this.http.post<AlertRuleInfo>(
      this.restApi.CREATE_ALERTRULE,
      payload,
      { headers: this.headers }
    );
  }

  /* =========================
     UPDATE ALERT RULE
     ========================= */
  updateAlertRule(id: number, payload: any): Observable<AlertRuleInfo> {
    const url = this.buildUrl(
      this.restApi.UPDATE_ALERTRULE,
      { id }
    );

    return this.http.post<AlertRuleInfo>(
      url,
      payload,
      { headers: this.headers }
    );
  }

  /* =========================
     DELETE ALERT RULE (SOFT)
     ========================= */
  deleteAlertRule(id: number): Observable<AlertRuleInfo> {
    const url = this.buildUrl(
      this.restApi.DELETE_ALERTRULE,
      { id }
    );

    return this.http.post<AlertRuleInfo>(
      url,
      { headers: this.headers }
    );
  }

  /* =========================
     GET ALL  ALERT RULES
     ========================= */
  getAllActiveAlertRules(): Observable<any[]> {
    return this.http.get<any[]>(
      this.restApi.GET_ALL_ALERT_RULE ,{ headers: this.headers }
    );
  }

  /* =========================
     GET ALERT RULE BY ID
     ========================= */
  getAlertRuleById(id: number): Observable<any> {
    const url = this.buildUrl(
      this.restApi.GET_ALERT_RULE_BY_ID,
      { id }
    );

    return this.http.get<any>(url ,{ headers: this.headers });
  }


  // ============================Alert Product MApping ============================

  getAllAlertProductMApping(page:number , size:number ,  productId?: string | null, source?: string | null, alertId?: string | null, mappingType?: string | null):Observable<any[]>{
    let params = new HttpParams()
          .set('page', page)
          .set('size',size)
        // Add filters only if present
        if (productId) {
          params = params.set('productId', productId);
        }

        if (source) {
          params = params.set('source', source);
        }
        if (alertId) {
          params = params.set('alertId', alertId);
        }
        if(mappingType){
          params = params.set('mappingType', mappingType);
        }
    

     const url=this.restApi.GET_ALL_ALERT_PRODUCT_MAPPING;

    return this.http.get<any[]>(url, { params  ,headers: this.headers});

  }

    getAllActiveAlertRulesLib(): Observable<any[]> {
    return this.http.get<any[]>(
      this.restApi.GET_ALL_ACTIVE_ALERTS_RULES ,{ headers: this.headers }
    );
  }

    manualUnMapALLSelectedProductToAlertRule(payload: any): Observable<AlertRuleInfo> {

    const url=this.restApi.MANUAL_UNMAP_SELECTED_PRODUCT_TO_ALERT_RULE;
    return this.http.post<AlertRuleInfo>(
      url,
      payload,
      { headers: this.headers }
    );
  }

    manualMapALLSelectedProductToAlertRule(payload: any,dnsId:any,WorkspaceId:any): Observable<AlertRuleInfo> {
      let params = new HttpParams()
          .set('dnsId', dnsId)
          .set('workspaceId',WorkspaceId)

    const url=this.restApi.MANUAL_MAP_SELECTED_PRODUCT_TO_ALERT_RULE;
    return this.http.post<AlertRuleInfo>(
      url,
      payload,
      { params, headers: this.headers }
    );
  }

  getAlertProductMappingSummary(): Observable<any> {
    return this.http.get<any>(
      this.restApi.GET_ALERT_PRODUCT_MAPPING_SUMMARY ,{ headers: this.headers }
    );
  }


}
